// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__1CzHT","particlesWrapper":"styles_particlesWrapper__3QslT"};